export enum MessageTypes {
    Standard = 0,
    StandardWithFiles = 1,
    RequestRevision = 2,
    RequestApproval = 3,
    CancelRequestRevision = 4,
    DoctorRating = 5,
    AIProcessFailed = 6,
    TreatmentNoteByLab = 60000,
}
